
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as bWFwbGlicmUtZ2w from 'maplibre-gl';
import * as bWFwbGlicmUtZ2wvZGlzdC9tYXBsaWJyZS1nbC5jc3M from 'maplibre-gl/dist/maplibre-gl.css';
import * as cG10aWxlcw from 'pmtiles';
import * as d2FzbTpqcy1zdHJpbmc from './amalyncare_fe.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;
let require;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    const module = await import(/* webpackIgnore: true */'node:module');
    const importMeta = import.meta;
    require = module.default.createRequire(importMeta.url);
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;
const _ref_bWFwbGlicmUtZ2w_ = bWFwbGlicmUtZ2w;
const _ref_bWFwbGlicmUtZ2wvZGlzdC9tYXBsaWJyZS1nbC5jc3M_ = bWFwbGlicmUtZ2wvZGlzdC9tYXBsaWJyZS1nbC5jc3M;
const _ref_cG10aWxlcw_ = cG10aWxlcw;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.io.printError' : (error) => console.error(error),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.backgroundColor_$external_prop_setter' : (_this, v) => _this.backgroundColor = v,
    'org.w3c.dom.css.border_$external_prop_setter' : (_this, v) => _this.border = v,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.fontSize_$external_prop_getter' : (_this) => _this.fontSize,
    'org.w3c.dom.css.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.getPropertyValue_$external_fun' : (_this, p0) => _this.getPropertyValue(p0),
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.Event_$external_fun' : (p0, p1, isDefault0) => new Event(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.stopPropagation_$external_fun' : (_this, ) => _this.stopPropagation(),
    'org.w3c.dom.events.stopImmediatePropagation_$external_fun' : (_this, ) => _this.stopImmediatePropagation(),
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
    'org.w3c.dom.events.DOM_DELTA_PIXEL_$external_prop_getter' : (_this) => _this.DOM_DELTA_PIXEL,
    'org.w3c.dom.events.DOM_DELTA_LINE_$external_prop_getter' : (_this) => _this.DOM_DELTA_LINE,
    'org.w3c.dom.events.DOM_DELTA_PAGE_$external_prop_getter' : (_this) => _this.DOM_DELTA_PAGE,
    'org.w3c.dom.events.Companion_$external_object_getInstance' : () => WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_instanceof' : (x) => x instanceof FocusEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_get' : () => FocusEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_3' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1, p2) => _this.removeEventListener(p0, p1, p2),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_2' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.dispatchEvent_$external_fun' : (_this, p0) => _this.dispatchEvent(p0),
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.className_$external_prop_setter' : (_this, v) => _this.className = v,
    'org.w3c.dom.classList_$external_prop_getter' : (_this) => _this.classList,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.innerHTML_$external_prop_setter' : (_this, v) => _this.innerHTML = v,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.removeAttribute_$external_fun' : (_this, p0) => _this.removeAttribute(p0),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.HTMLFormElement_$external_class_instanceof' : (x) => x instanceof HTMLFormElement,
    'org.w3c.dom.HTMLFormElement_$external_class_get' : () => HTMLFormElement,
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.history_$external_prop_getter' : (_this) => _this.history,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
    'org.w3c.dom.cancelAnimationFrame_$external_fun' : (_this, p0) => _this.cancelAnimationFrame(p0),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.getComputedStyle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getComputedStyle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.origin_$external_prop_getter' : (_this) => _this.origin,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.hostname_$external_prop_getter' : (_this) => _this.hostname,
    'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'org.w3c.dom.hash_$external_prop_getter' : (_this) => _this.hash,
    'org.w3c.dom.assign_$external_fun' : (_this, p0) => _this.assign(p0),
    'org.w3c.dom.title_$external_prop_setter' : (_this, v) => _this.title = v,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.offsetWidth_$external_prop_getter' : (_this) => _this.offsetWidth,
    'org.w3c.dom.offsetHeight_$external_prop_getter' : (_this) => _this.offsetHeight,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.head_$external_prop_getter' : (_this) => _this.head,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.querySelector_$external_fun' : (_this, p0) => _this.querySelector(p0),
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.parentNode_$external_prop_getter' : (_this) => _this.parentNode,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.insertBefore_$external_fun' : (_this, p0, p1) => _this.insertBefore(p0, p1),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.Node_$external_class_instanceof' : (x) => x instanceof Node,
    'org.w3c.dom.Node_$external_class_get' : () => Node,
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.add_$external_fun' : (_this, p0) => _this.add(...p0),
    'org.w3c.dom.toggle_$external_fun' : (_this, p0, p1, isDefault0) => _this.toggle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.children_$external_prop_getter' : (_this) => _this.children,
    'org.w3c.dom.append_$external_fun' : (_this, p0) => _this.append(...p0),
    'org.w3c.dom.querySelector_$external_fun_1' : (_this, p0) => _this.querySelector(p0),
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.btoa_$external_fun' : (_this, p0) => _this.btoa(p0),
    'org.w3c.dom.setTimeout_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1) => _this.setTimeout(p0, isDefault0 ? undefined : p1, ...p2, ),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_(()->Js?)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Js?)'](f, )),
    'org.w3c.dom.clearTimeout_$external_fun' : (_this, p0, isDefault0) => _this.clearTimeout(isDefault0 ? undefined : p0, ),
    'org.w3c.dom.setInterval_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1) => _this.setInterval(p0, isDefault0 ? undefined : p1, ...p2, ),
    'org.w3c.dom.clearInterval_$external_fun' : (_this, p0, isDefault0) => _this.clearInterval(isDefault0 ? undefined : p0, ),
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.localStorage_$external_prop_getter' : (_this) => _this.localStorage,
    'org.w3c.dom.state_$external_prop_getter' : (_this) => _this.state,
    'org.w3c.dom.go_$external_fun' : (_this, p0, isDefault0) => _this.go(isDefault0 ? undefined : p0, ),
    'org.w3c.dom.back_$external_fun' : (_this, ) => _this.back(),
    'org.w3c.dom.pushState_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.pushState(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.replaceState_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.replaceState(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.alt_$external_prop_setter' : (_this, v) => _this.alt = v,
    'org.w3c.dom.src_$external_prop_setter' : (_this, v) => _this.src = v,
    'org.w3c.dom.download_$external_prop_setter' : (_this, v) => _this.download = v,
    'org.w3c.dom.rel_$external_prop_setter' : (_this, v) => _this.rel = v,
    'org.w3c.dom.contentDocument_$external_prop_getter' : (_this) => _this.contentDocument,
    'org.w3c.dom.HTMLIFrameElement_$external_class_instanceof' : (x) => x instanceof HTMLIFrameElement,
    'org.w3c.dom.HTMLIFrameElement_$external_class_get' : () => HTMLIFrameElement,
    'org.w3c.dom.accept_$external_prop_setter' : (_this, v) => _this.accept = v,
    'org.w3c.dom.disabled_$external_prop_setter' : (_this, v) => _this.disabled = v,
    'org.w3c.dom.files_$external_prop_getter' : (_this) => _this.files,
    'org.w3c.dom.multiple_$external_prop_setter' : (_this, v) => _this.multiple = v,
    'org.w3c.dom.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'org.w3c.dom.value_$external_prop_getter' : (_this) => _this.value,
    'org.w3c.dom.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'org.w3c.dom.HTMLInputElement_$external_class_instanceof' : (x) => x instanceof HTMLInputElement,
    'org.w3c.dom.HTMLInputElement_$external_class_get' : () => HTMLInputElement,
    'org.w3c.dom.HTMLButtonElement_$external_class_instanceof' : (x) => x instanceof HTMLButtonElement,
    'org.w3c.dom.HTMLButtonElement_$external_class_get' : () => HTMLButtonElement,
    'org.w3c.dom.href_$external_prop_setter' : (_this, v) => _this.href = v,
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_instanceof' : (x) => x instanceof PointerEvent,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_get' : () => PointerEvent,
    'org.w3c.dom.url.createObjectURL_$external_fun' : (_this, p0) => _this.createObjectURL(p0),
    'org.w3c.dom.url.revokeObjectURL_$external_fun' : (_this, p0) => _this.revokeObjectURL(p0),
    'org.w3c.dom.url.Companion_$external_object_getInstance' : () => URL,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.arrayBuffer_$external_fun' : (_this, ) => _this.arrayBuffer(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.Response_$external_class_instanceof' : (x) => x instanceof Response,
    'org.w3c.fetch.Response_$external_class_get' : () => Response,
    'org.w3c.files.BlobPropertyBag_js_code' : (type) => ({ type: type }),
    'org.w3c.files.Blob_$external_fun' : (p0, p1, isDefault0, isDefault1) => new Blob(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.files.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.files.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.files.name_$external_prop_getter' : (_this) => _this.name,
    'org.w3c.files.File_$external_class_instanceof' : (x) => x instanceof File,
    'org.w3c.files.File_$external_class_get' : () => File,
    'org.w3c.files.FileReader_$external_fun' : () => new FileReader(),
    'org.w3c.files.result_$external_prop_getter' : (_this) => _this.result,
    'org.w3c.files.onload_$external_prop_setter' : (_this, v) => _this.onload = v,
    'org.w3c.files.onabort_$external_prop_setter' : (_this, v) => _this.onabort = v,
    'org.w3c.files.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
    'org.w3c.files.readAsArrayBuffer_$external_fun' : (_this, p0) => _this.readAsArrayBuffer(p0),
    'org.w3c.files.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'org.w3c.xhr.FormData_$external_fun' : (p0, isDefault0) => new FormData(isDefault0 ? undefined : p0, ),
    'org.w3c.xhr.append_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.append(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.xhr.FormData_$external_class_instanceof' : (x) => x instanceof FormData,
    'org.w3c.xhr.FormData_$external_class_get' : () => FormData,
    'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
    'org.w3c.xhr.timeout_$external_prop_setter' : (_this, v) => _this.timeout = v,
    'org.w3c.xhr.withCredentials_$external_prop_setter' : (_this, v) => _this.withCredentials = v,
    'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.xhr.responseType_$external_prop_setter' : (_this, v) => _this.responseType = v,
    'org.w3c.xhr.response_$external_prop_getter' : (_this) => _this.response,
    'org.w3c.xhr.responseText_$external_prop_getter' : (_this) => _this.responseText,
    'org.w3c.xhr.open_$external_fun' : (_this, p0, p1) => _this.open(p0, p1),
    'org.w3c.xhr.setRequestHeader_$external_fun' : (_this, p0, p1) => _this.setRequestHeader(p0, p1),
    'org.w3c.xhr.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.xhr.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.xhr.send_$external_fun_2' : (_this, ) => _this.send(),
    'org.w3c.xhr.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.w3c.xhr.getResponseHeader_$external_fun' : (_this, p0) => _this.getResponseHeader(p0),
    'org.w3c.xhr.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.xhr.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
    'org.w3c.xhr.onload_$external_prop_setter' : (_this, v) => _this.onload = v,
    'org.w3c.xhr.ontimeout_$external_prop_setter' : (_this, v) => _this.ontimeout = v,
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.defaultFetchInit_js_code' : () => ({}),
    'org.jetbrains.skiko.jsCatch' : function (f) { try { f(); } catch (e) { return e;}; return null; },
    'org.jetbrains.skiko.jsThrow' : (e) => { throw e; },
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._script_$external_prop_getter' : (_this) => _this.script,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isVibrationSupported' : () => 
            typeof window !== 'undefined' &&
            window.navigator != null &&
            typeof window.navigator.vibrate === 'function'
        ,
    'androidx.compose.ui.platform.vibrate' : (pattern) => { window.navigator.vibrate(pattern) },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.isFullWakeLockApiSupported' : () => Boolean(
            window.navigator.wakeLock && 
            typeof(WakeLockSentinel) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.viewinterop.toggleVisibility' : (element, isHidden) => { 
           element.style.visibility = isHidden ? "hidden" : "visible";
         },
    'androidx.compose.ui.viewinterop.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.viewinterop.setClipPath' : (element, top, right, bottom, left) => { 
           element.style.setProperty("clip-path", "inset(" + top + "px " + right + "px " + bottom + "px " + left + "px)"); 
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isTouchEvent' : (event) => event.pointerType === 'touch',
    'androidx.compose.ui.window.releasePointerCapture' : (target, pointerId) => { try { target.releasePointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.gestures.legacyWheelDeltaX' : (event) => (event.wheelDeltaX == null) ? NaN : event.wheelDeltaX,
    'androidx.compose.foundation.gestures.legacyWheelDeltaY' : (event) => (event.wheelDeltaY == null) ? NaN : event.wheelDeltaY,
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.script_$external_prop_getter' : (_this) => _this.script,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.jsFetchWithSignal' : (url, signal) => window.fetch(url, { signal }),
    'org.jetbrains.compose.resources.AbortController_$external_fun' : () => new AbortController(),
    'org.jetbrains.compose.resources.signal_$external_prop_getter' : (_this) => _this.signal,
    'org.jetbrains.compose.resources.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.jetbrains.compose.resources.isWasmExportsAvailable' : () => typeof wasmExports !== 'undefined',
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'com.amalyncare.uikit.components.actions.registerChoiceSemanticsNative' : (id, label, role, checked, enabled, readOnly) => {
            const markerSeparator = '\u001D';
            const bridgeKey = '__amalynChoiceSemanticsBridge';
            const bridge = globalThis[bridgeKey] || {
                registry: new Map(),
                observedRoots: new Set(),
                observers: [],
                scheduled: false,
            };
            globalThis[bridgeKey] = bridge;
            const collectRoots = (root) => [
                root,
                ...Array.from(root.querySelectorAll('*'))
                    .filter((element) => element.shadowRoot)
                    .flatMap((element) => collectRoots(element.shadowRoot)),
            ];
            const setAttribute = (element, name, value) => {
                if (element.getAttribute(name) !== value) {
                    element.setAttribute(name, value);
                }
            };
            const removeAttribute = (element, name) => {
                if (element.hasAttribute(name)) {
                    element.removeAttribute(name);
                }
            };
            const synchronizeAll = () => {
                collectRoots(document).forEach((root) => {
                    if (bridge.observedRoots.has(root)) {
                        return;
                    }
                    const observer = new MutationObserver(() => {
                        if (bridge.scheduled) {
                            return;
                        }
                        bridge.scheduled = true;
                        requestAnimationFrame(() => {
                            bridge.scheduled = false;
                            synchronizeAll();
                        });
                    });
                    observer.observe(root, {
                        subtree: true,
                        childList: true,
                        attributes: true,
                        attributeFilter: ['aria-label', 'role', 'aria-checked', 'aria-disabled', 'aria-readonly'],
                    });
                    bridge.observedRoots.add(root);
                    bridge.observers.push(observer);
                });
                const elements = collectRoots(document)
                    .flatMap((root) => Array.from(root.querySelectorAll('[aria-label], [data-amalyn-choice-id]')));
                bridge.registry.forEach((config) => {
                    const element = elements.find((candidate) =>
                        candidate.getAttribute('data-amalyn-choice-id') === config.id
                    ) || elements.find((candidate) =>
                        (candidate.getAttribute('aria-label') || '').endsWith(markerSeparator + config.id)
                    );
                    if (!element) {
                        return;
                    }
                    setAttribute(element, 'data-amalyn-choice-id', config.id);
                    setAttribute(element, 'role', config.role);
                    if (config.label) {
                        setAttribute(element, 'aria-label', config.label);
                    } else {
                        removeAttribute(element, 'aria-label');
                    }
                    if (config.role === 'radiogroup') {
                        return;
                    }
                    setAttribute(element, 'aria-checked', String(config.checked));
                    setAttribute(element, 'aria-disabled', String(!config.enabled));
                    if (config.readOnly) {
                        setAttribute(element, 'aria-readonly', 'true');
                    } else {
                        removeAttribute(element, 'aria-readonly');
                    }
                });
            };
            bridge.registry.set(id, { id, label, role, checked, enabled, readOnly });
            synchronizeAll();
        },
    'com.amalyncare.uikit.components.actions.unregisterChoiceSemanticsNative' : (id) => {
            const bridgeKey = '__amalynChoiceSemanticsBridge';
            const bridge = globalThis[bridgeKey];
            if (!bridge) {
                return;
            }
            bridge.registry.delete(id);
            if (bridge.registry.size === 0) {
                bridge.observers.forEach((observer) => observer.disconnect());
                delete globalThis[bridgeKey];
            }
        },
    'com.amalyncare.uikit.components.dialogs.restoreNativeComposeHostFocus' : () => {
            const collectRoots = (root) => [
                root,
                ...Array.from(root.querySelectorAll('*'))
                    .filter((element) => element.shadowRoot)
                    .flatMap((element) => collectRoots(element.shadowRoot)),
            ];
            const canvas = collectRoots(document)
                .flatMap((root) => Array.from(root.querySelectorAll('canvas[tabindex="0"]')))
                .find((candidate) => {
                    const bounds = candidate.getBoundingClientRect();
                    return bounds.width > 0 && bounds.height > 0;
                });
            canvas?.focus({ preventScroll: true });
        },
    'com.amalyncare.uikit.components.dialogs.captureComposeBackingInputTabOwner' : (event) => {
            const path = event.composedPath();
            const target = path[0];
            let active = document.activeElement;
            while (active?.shadowRoot?.activeElement) {
                active = active.shadowRoot.activeElement;
            }
            if (
                target !== active ||
                !(target instanceof HTMLElement) ||
                !target.matches('.compose-backing-field')
            ) {
                return false;
            }

            const canvas = target.parentElement?.querySelector(':scope > canvas[tabindex="0"]');
            if (!(canvas instanceof HTMLCanvasElement)) return false;
            event.__amalynQueuedTabOwnerCanvas = canvas;
            return true;
        },
    'com.amalyncare.uikit.components.dialogs.restoreNativeComposeHostFocusAfterTab' : (event) => {
            let active = document.activeElement;
            while (active?.shadowRoot?.activeElement) {
                active = active.shadowRoot.activeElement;
            }
            if (
                active &&
                (active.tagName === "INPUT" || active.tagName === "TEXTAREA" || active.isContentEditable)
            ) {
                return;
            }

            const path = event.composedPath();
            const directCanvas = path.find((node) =>
                node instanceof HTMLCanvasElement && node.matches('canvas[tabindex="0"]')
            );
            const ownerRoot = directCanvas ? null : path.find((node) =>
                (node instanceof ShadowRoot || node instanceof Document) &&
                node.querySelector?.('canvas[tabindex="0"]')
            );
            const canvas = directCanvas ?? ownerRoot?.querySelector('canvas[tabindex="0"]');
            if (!canvas?.isConnected) return;
            const bounds = canvas.getBoundingClientRect();
            if (bounds.width <= 0 || bounds.height <= 0) return;
            canvas.focus({ preventScroll: true });
        },
    'com.amalyncare.uikit.components.dialogs.restoreNativeComposeHostFocusAfterQueuedTab' : (event) => {
            const canvas = event.__amalynQueuedTabOwnerCanvas;
            delete event.__amalynQueuedTabOwnerCanvas;
            if (!(canvas instanceof HTMLCanvasElement) || !canvas.isConnected) return;

            let active = document.activeElement;
            while (active?.shadowRoot?.activeElement) {
                active = active.shadowRoot.activeElement;
            }
            if (
                active &&
                (active.tagName === "INPUT" || active.tagName === "TEXTAREA" || active.isContentEditable)
            ) {
                return;
            }

            const bounds = canvas.getBoundingClientRect();
            if (bounds.width <= 0 || bounds.height <= 0) return;
            canvas.focus({ preventScroll: true });
        },
    'com.amalyncare.uikit.components.forms.amalynScrollHtmlPreviewBy' : (iframe, delta) => {
            try {
                const win = iframe?.contentWindow ?? null;
                if (win) {
                    win.scrollBy(0, delta);
                }
            } catch (_) {
            }
        },
    'com.amalyncare.uikit.components.forms.amalynHtmlPreviewWheelClientX' : (event) => event?.clientX ?? 0,
    'com.amalyncare.uikit.components.forms.amalynHtmlPreviewWheelClientY' : (event) => event?.clientY ?? 0,
    'com.amalyncare.uikit.components.forms.amalynHtmlPreviewWheelDeltaY' : (event) => event?.deltaY ?? 0,
    'com.amalyncare.uikit.components.forms.amalynConsumeHtmlPreviewWheelEvent' : (event) => {
            event?.preventDefault?.();
            event?.stopPropagation?.();
            event?.stopImmediatePropagation?.();
        },
    'com.amalyncare.uikit.components.forms.amalynInstallHtmlPreviewScrollChaining' : (iframe, scrollParentBy) => {
            const childDocument = iframe.contentDocument;
            if (!childDocument || childDocument.__amalynPreviewScrollChaining) return;
            childDocument.__amalynPreviewScrollChaining = true;
            childDocument.addEventListener('wheel', (event) => {
                if (event.ctrlKey || event.defaultPrevented || event.deltaY === 0) return;
                const scroller = childDocument.scrollingElement;
                if (!scroller) return;
                const canScroll = (element, delta, horizontal) => {
                    if (!delta) return false;
                    const style = childDocument.defaultView.getComputedStyle(element);
                    const overflow = horizontal ? style.overflowX : style.overflowY;
                    if (element !== scroller && overflow !== 'auto' && overflow !== 'scroll') return false;
                    const max = horizontal ? element.scrollWidth - element.clientWidth : element.scrollHeight - element.clientHeight;
                    const value = horizontal ? element.scrollLeft : element.scrollTop;
                    return delta > 0 ? value < max - 1 : value > 0;
                };
                let element = event.target instanceof childDocument.defaultView.Element ? event.target : event.target.parentElement;
                while (element) {
                    if (canScroll(element, event.deltaY, false) || canScroll(element, event.deltaX, true)) return;
                    element = element.parentElement;
                }
                const scale = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? scroller.clientHeight : 1;
                scrollParentBy(event.deltaY * scale);
                event.preventDefault();
            }, { passive: false });
        },
    'com.amalyncare.uikit.components.forms.amalynFitHtmlPreviewDocument' : (iframe, zoom) => {
            const doc = iframe.contentDocument;
            if (doc?.documentElement.getAttribute('data-amalyn-document-preview-pagination') !== 'paginated') return false;
            const viewportWidth = doc.documentElement.clientWidth;
            if (viewportWidth <= 0) return true;
            const body = doc.body;
            const key = viewportWidth + ':' + zoom;
            if (body.dataset.amalynPreviewZoom === key) return true;
            const style = iframe.contentWindow.getComputedStyle(body);
            const naturalWidth = 816 + parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
            const scale = Math.min(1, viewportWidth / naturalWidth) * zoom;
            body.style.setProperty('box-sizing', 'border-box', 'important');
            body.style.setProperty('min-width', naturalWidth + 'px', 'important');
            body.style.setProperty('width', Math.max(naturalWidth, viewportWidth / scale) + 'px', 'important');
            body.style.setProperty('zoom', String(scale));
            body.dataset.amalynPreviewZoom = key;
            if (zoom === 1) iframe.contentWindow.scrollTo(0, iframe.contentWindow.scrollY);
            return true;
        },
    'com.amalyncare.uikit.components.forms.amalynSearchHtmlPreview' : (iframe, query, requestedIndex) => {
            try {
                const childDocument = iframe?.contentDocument ?? null;
                const body = childDocument?.body ?? null;
                if (!childDocument || !body) {
                    return '0|0';
                }

                const normalizedQuery = String(query ?? '').trim().toLocaleLowerCase();
                const searchState = childDocument.__amalynDocumentPreviewSearch ?? null;
                const clearMatches = () => {
                    childDocument.querySelectorAll('mark[data-amalyn-document-preview-match]').forEach((mark) => {
                        const parent = mark.parentNode;
                        if (parent) {
                            parent.replaceChild(childDocument.createTextNode(mark.textContent ?? ''), mark);
                        }
                    });
                    body.normalize();
                    childDocument.defaultView?.getSelection?.()?.removeAllRanges?.();
                };

                if (!normalizedQuery) {
                    if (searchState) {
                        clearMatches();
                        delete childDocument.__amalynDocumentPreviewSearch;
                    }
                    return '0|0';
                }

                let state = searchState;
                if (!state || state.query !== normalizedQuery) {
                    if (searchState) {
                        clearMatches();
                    }
                    const matches = [];
                    const walker = childDocument.createTreeWalker(body, 4);
                    let node = walker.nextNode();
                    while (node) {
                        const parent = node.parentElement;
                        const excluded = parent?.closest?.(
                            'script,style,template,textarea,input,select,option,[hidden],[aria-hidden="true"]',
                        );
                        if (!excluded) {
                            const value = node.nodeValue ?? '';
                            const lowerValue = value.toLocaleLowerCase();
                            let start = lowerValue.indexOf(normalizedQuery);
                            while (start >= 0) {
                                matches.push({ node, start });
                                start = lowerValue.indexOf(normalizedQuery, start + normalizedQuery.length);
                            }
                        }
                        node = walker.nextNode();
                    }

                    for (let index = matches.length - 1; index >= 0; index -= 1) {
                        const match = matches[index];
                        if (!match.node.parentNode) {
                            continue;
                        }
                        const matchedNode = match.node.splitText(match.start);
                        matchedNode.splitText(normalizedQuery.length);
                        const mark = childDocument.createElement('mark');
                        mark.setAttribute('data-amalyn-document-preview-match', '');
                        mark.textContent = matchedNode.nodeValue ?? '';
                        mark.style.backgroundColor = '#ffe08a';
                        mark.style.color = 'inherit';
                        mark.style.padding = '0 1px';
                        matchedNode.replaceWith(mark);
                    }

                    state = {
                        query: normalizedQuery,
                        marks: Array.from(childDocument.querySelectorAll('mark[data-amalyn-document-preview-match]')),
                        activeIndex: -1,
                    };
                    childDocument.__amalynDocumentPreviewSearch = state;
                }

                const marks = state.marks.filter((mark) => mark?.isConnected);
                state.marks = marks;
                if (marks.length === 0) {
                    state.activeIndex = -1;
                    return '0|0';
                }

                const numericIndex = Number(requestedIndex);
                const safeRequestedIndex = Number.isFinite(numericIndex) ? Math.trunc(numericIndex) : 0;
                const activeIndex = ((safeRequestedIndex % marks.length) + marks.length) % marks.length;
                if (state.activeIndex !== activeIndex) {
                    marks.forEach((mark) => {
                        mark.removeAttribute('data-amalyn-document-preview-active');
                        mark.style.backgroundColor = '#ffe08a';
                    });
                    const activeMark = marks[activeIndex];
                    activeMark.setAttribute('data-amalyn-document-preview-active', '');
                    activeMark.style.backgroundColor = '#ffb74d';
                    activeMark.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'auto' });
                    state.activeIndex = activeIndex;
                }
                return activeIndex + '|' + marks.length;
            } catch (_) {
                return '0|0';
            }
        },
    'com.amalyncare.uikit.components.forms.amalynHtmlPreviewScrollValue' : (iframe) => {
            try {
                const win = iframe?.contentWindow ?? null;
                const documentElement = win?.document?.documentElement ?? null;
                const body = win?.document?.body ?? null;
                return Math.ceil(Math.max(
                    win?.scrollY ?? 0,
                    documentElement?.scrollTop ?? 0,
                    body?.scrollTop ?? 0,
                ));
            } catch (_) {
                return 0;
            }
        },
    'com.amalyncare.uikit.components.forms.amalynHtmlPreviewMaxScroll' : (iframe) => {
            try {
                const scroller = iframe?.contentDocument?.scrollingElement;
                if (!scroller) return 0;
                return Math.max(0, Math.ceil(scroller.scrollHeight - scroller.clientHeight));
            } catch (_) {
                return 0;
            }
        },
    'com.amalyncare.uikit.components.forms.amalynInstallHtmlPreviewScrollbarStyle' : (iframe) => {
            try {
                const childDocument = iframe?.contentDocument ?? iframe?.contentWindow?.document ?? null;
                if (!childDocument || childDocument.getElementById('amalyn-html-preview-scrollbar-style')) {
                    return;
                }
                const style = childDocument.createElement('style');
                style.id = 'amalyn-html-preview-scrollbar-style';
                style.textContent = `
                    html,
                    body {
                        scrollbar-width: none;
                        -ms-overflow-style: none;
                    }
                    html::-webkit-scrollbar,
                    body::-webkit-scrollbar {
                        width: 0;
                        height: 0;
                    }
                `;
                (childDocument.head || childDocument.documentElement).appendChild(style);
            } catch (_) {
            }
        },
    'com.amalyncare.uikit.components.forms.amalynPrepareHtmlPreviewPagination' : (iframe, maxBlocks) => {
            try {
                const childDocument = iframe?.contentDocument ?? iframe?.contentWindow?.document ?? null;
                const childWindow = iframe?.contentWindow ?? null;
                if (!childDocument || !childWindow || childDocument.readyState !== 'complete') {
                    return -1;
                }
                const documentElement = childDocument.documentElement;
                const preparedAttribute = 'data-amalyn-document-preview-pagination';
                if (documentElement.hasAttribute(preparedAttribute)) {
                    return -1;
                }
                const headerTemplate = childDocument.querySelector('template[data-amalyn-document-preview-header]');
                const footerTemplate = childDocument.querySelector('template[data-amalyn-document-preview-footer]');
                if (!headerTemplate || !footerTemplate) {
                    documentElement.setAttribute(preparedAttribute, 'passthrough');
                    return -1;
                }

                const source =
                    childDocument.querySelector('main.document') ??
                    childDocument.querySelector('main.ac-document-page') ??
                    childDocument.querySelector('main') ??
                    childDocument.body;
                if (!source) {
                    return -1;
                }
                const sourceElements = Array.from(source.children).filter((element) => element.tagName !== 'TEMPLATE');
                if (sourceElements.length > maxBlocks) {
                    documentElement.setAttribute(preparedAttribute, 'passthrough-limit');
                    return -1;
                }

                const pageStyle = childDocument.createElement('style');
                pageStyle.id = 'amalyn-html-document-preview-pagination-style';
                pageStyle.textContent = `
                    html {
                        background: #eef2f5 !important;
                    }
                    body {
                        min-width: calc(8.5in + 48px) !important;
                        min-height: 100% !important;
                        margin: 0 !important;
                        padding: 24px 24px 96px !important;
                        overflow: auto !important;
                        background: #eef2f5 !important;
                    }
                    .amalyn-document-preview-page-stack {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        gap: 24px;
                        width: 100%;
                        min-width: 8.5in;
                    }
                    .amalyn-document-preview-page {
                        display: grid;
                        grid-template-rows: 0.62in minmax(0, 1fr) 0.65in;
                        flex: 0 0 auto;
                        box-sizing: border-box;
                        width: 8.5in;
                        height: 11in;
                        padding: 0.23in 0 0.35in;
                        overflow: hidden;
                        background: #fff;
                        outline: 1px solid #d8dadd;
                        box-shadow: 0 3px 16px rgba(0, 0, 0, 0.12);
                    }
                    .amalyn-document-preview-page-header,
                    .amalyn-document-preview-page-footer {
                        min-width: 0;
                        overflow: hidden;
                    }
                    .amalyn-document-preview-page-header {
                        align-self: start;
                    }
                    .amalyn-document-preview-page-footer {
                        align-self: end;
                    }
                    .amalyn-document-preview-page-content {
                        box-sizing: border-box;
                        width: auto !important;
                        max-width: none !important;
                        min-width: 0;
                        min-height: 0;
                        margin: 0 !important;
                        padding: 0 0.75in !important;
                        overflow: hidden;
                        background: transparent !important;
                        border: 0 !important;
                        box-shadow: none !important;
                    }
                    .amalyn-document-preview-page[data-amalyn-document-preview-oversized='true']
                        .amalyn-document-preview-page-content {
                        overflow-y: auto;
                    }
                    .amalyn-document-preview-measurement {
                        position: absolute;
                        left: -100000px;
                        top: 0;
                        visibility: hidden;
                        pointer-events: none;
                    }
                    .amalyn-document-preview-measurement-block {
                        display: flow-root;
                        width: 100%;
                    }
                    .amalyn-document-preview-page-content table,
                    .amalyn-document-preview-page-content .standalone-signing-field,
                    .amalyn-document-preview-page-content .amalyn-preview-field,
                    .amalyn-document-preview-page-content signature-field,
                    .amalyn-document-preview-page-content date-field,
                    .amalyn-document-preview-page-content text-field,
                    .amalyn-document-preview-page-content checkbox-field,
                    .amalyn-document-preview-page-content radio-field,
                    .amalyn-document-preview-page-content multi-select-field {
                        break-inside: avoid-page;
                        page-break-inside: avoid;
                    }
                    @media (max-width: 900px) {
                        body {
                            min-width: calc(8.5in + 24px) !important;
                            padding: 12px 12px 72px !important;
                        }
                    }
                `;
                (childDocument.head || documentElement).appendChild(pageStyle);

                const pageBreakValue = (value) => {
                    const normalized = String(value ?? '').toLowerCase();
                    return normalized === 'page' || normalized === 'always' ||
                        normalized === 'left' || normalized === 'right' ||
                        normalized === 'recto' || normalized === 'verso';
                };
                const avoidValue = (value) => String(value ?? '').toLowerCase().startsWith('avoid');
                const blocks = sourceElements.map((element) => {
                    const computedStyle = childWindow.getComputedStyle(element);
                    const pageBreakMarker = element.classList.contains('page-break');
                    return {
                        element: element.cloneNode(true),
                        height: 0,
                        pageBreakBefore: pageBreakMarker || pageBreakValue(computedStyle.breakBefore) ||
                            pageBreakValue(computedStyle.pageBreakBefore),
                        pageBreakAfter: pageBreakValue(computedStyle.breakAfter) ||
                            pageBreakValue(computedStyle.pageBreakAfter),
                        keepWithPrevious: avoidValue(computedStyle.breakBefore) ||
                            avoidValue(computedStyle.pageBreakBefore),
                        keepWithNext: avoidValue(computedStyle.breakAfter) ||
                            avoidValue(computedStyle.pageBreakAfter),
                        pageBreakMarker: pageBreakMarker,
                    };
                });

                const createPage = () => {
                    const page = childDocument.createElement('section');
                    page.className = 'amalyn-document-preview-page';
                    page.setAttribute('data-amalyn-document-preview-page', '');
                    const header = childDocument.createElement('header');
                    header.className = 'amalyn-document-preview-page-header';
                    header.setAttribute('data-amalyn-document-preview-page-header', '');
                    header.appendChild(headerTemplate.content.cloneNode(true));
                    const content = childDocument.createElement('main');
                    content.className = 'amalyn-document-preview-page-content';
                    source.classList.forEach((className) => content.classList.add(className));
                    content.setAttribute('data-amalyn-document-preview-page-content', '');
                    const footer = childDocument.createElement('footer');
                    footer.className = 'amalyn-document-preview-page-footer';
                    footer.setAttribute('data-amalyn-document-preview-page-footer', '');
                    footer.appendChild(footerTemplate.content.cloneNode(true));
                    page.append(header, content, footer);
                    return { page, content };
                };

                const measurementRoot = childDocument.createElement('div');
                measurementRoot.className = 'amalyn-document-preview-measurement';
                const measurementPage = createPage();
                measurementRoot.appendChild(measurementPage.page);
                childDocument.body.appendChild(measurementRoot);
                blocks.forEach((block) => {
                    if (block.pageBreakMarker) {
                        return;
                    }
                    const measurementBlock = childDocument.createElement('div');
                    measurementBlock.className = 'amalyn-document-preview-measurement-block';
                    measurementBlock.appendChild(block.element.cloneNode(true));
                    measurementPage.content.appendChild(measurementBlock);
                    block.height = measurementBlock.getBoundingClientRect().height;
                    measurementBlock.remove();
                });

                childDocument.__amalynDocumentPreviewPagination = {
                    blocks,
                    createPage,
                    measurementRoot,
                    availableHeight: measurementPage.content.clientHeight,
                    pages: [],
                };
                return blocks.length;
            } catch (_) {
                return -1;
            }
        },
    'com.amalyncare.uikit.components.forms.amalynHtmlPreviewAvailablePageHeight' : (iframe) => iframe?.contentDocument?.__amalynDocumentPreviewPagination?.availableHeight ?? 0,
    'com.amalyncare.uikit.components.forms.amalynHtmlPreviewBlockHeight' : (iframe, index) => iframe?.contentDocument?.__amalynDocumentPreviewPagination?.blocks?.[index]?.height ?? 0,
    'com.amalyncare.uikit.components.forms.amalynHtmlPreviewBlockPageBreakBefore' : (iframe, index) => Boolean(iframe?.contentDocument?.__amalynDocumentPreviewPagination?.blocks?.[index]?.pageBreakBefore),
    'com.amalyncare.uikit.components.forms.amalynHtmlPreviewBlockPageBreakAfter' : (iframe, index) => Boolean(iframe?.contentDocument?.__amalynDocumentPreviewPagination?.blocks?.[index]?.pageBreakAfter),
    'com.amalyncare.uikit.components.forms.amalynHtmlPreviewBlockKeepWithPrevious' : (iframe, index) => Boolean(iframe?.contentDocument?.__amalynDocumentPreviewPagination?.blocks?.[index]?.keepWithPrevious),
    'com.amalyncare.uikit.components.forms.amalynHtmlPreviewBlockKeepWithNext' : (iframe, index) => Boolean(iframe?.contentDocument?.__amalynDocumentPreviewPagination?.blocks?.[index]?.keepWithNext),
    'com.amalyncare.uikit.components.forms.amalynHtmlPreviewBlockIsPageBreakMarker' : (iframe, index) => Boolean(iframe?.contentDocument?.__amalynDocumentPreviewPagination?.blocks?.[index]?.pageBreakMarker),
    'com.amalyncare.uikit.components.forms.amalynCancelHtmlPreviewPagination' : (iframe) => {
            const childDocument = iframe?.contentDocument ?? null;
            const state = childDocument?.__amalynDocumentPreviewPagination ?? null;
            state?.measurementRoot?.remove();
            childDocument?.getElementById('amalyn-html-document-preview-pagination-style')?.remove();
            if (childDocument) {
                delete childDocument.__amalynDocumentPreviewPagination;
                childDocument.documentElement.setAttribute(
                    'data-amalyn-document-preview-pagination',
                    'passthrough-limit',
                );
            }
        },
    'com.amalyncare.uikit.components.forms.amalynBeginHtmlPreviewPageRendering' : (iframe, pageCount) => {
            const childDocument = iframe?.contentDocument ?? null;
            const state = childDocument?.__amalynDocumentPreviewPagination ?? null;
            if (!childDocument || !state) {
                return;
            }
            state.measurementRoot.remove();
            const stack = childDocument.createElement('div');
            stack.className = 'amalyn-document-preview-page-stack';
            stack.setAttribute('data-amalyn-document-preview-pages', '');
            state.pages = [];
            for (let index = 0; index < pageCount; index += 1) {
                const page = state.createPage();
                state.pages.push(page);
                stack.appendChild(page.page);
            }
            childDocument.body.replaceChildren(stack);
        },
    'com.amalyncare.uikit.components.forms.amalynAppendHtmlPreviewBlock' : (iframe, pageIndex, sourceIndex) => {
            const state = iframe?.contentDocument?.__amalynDocumentPreviewPagination ?? null;
            const page = state?.pages?.[pageIndex] ?? null;
            const block = state?.blocks?.[sourceIndex] ?? null;
            if (page && block && !block.pageBreakMarker) {
                page.content.appendChild(block.element.cloneNode(true));
            }
        },
    'com.amalyncare.uikit.components.forms.amalynMarkHtmlPreviewPageOversized' : (iframe, pageIndex) => {
            const page = iframe?.contentDocument?.__amalynDocumentPreviewPagination?.pages?.[pageIndex] ?? null;
            page?.page?.setAttribute('data-amalyn-document-preview-oversized', 'true');
        },
    'com.amalyncare.uikit.components.forms.amalynFinishHtmlPreviewPageRendering' : (iframe) => {
            const childDocument = iframe?.contentDocument ?? null;
            const state = childDocument?.__amalynDocumentPreviewPagination ?? null;
            if (!childDocument || !state) {
                return;
            }
            const totalPages = state.pages.length;
            state.pages.forEach((page, index) => {
                page.page.querySelectorAll('.pageNumber').forEach((element) => {
                    element.textContent = String(index + 1);
                });
                page.page.querySelectorAll('.totalPages').forEach((element) => {
                    element.textContent = String(totalPages);
                });
            });
            childDocument.documentElement.setAttribute('data-amalyn-document-preview-pagination', 'paginated');
            delete childDocument.__amalynDocumentPreviewPagination;
        },
    'com.amalyncare.uikit.components.forms.registerAutocompleteSemanticsNative' : (semanticId, label, expanded, multiSelectable, readOnly, activeOptionIndex, encodedOptions) => {
            const listSeparator = '\u001F';
            const stateSeparator = '\u001E';
            const markerSeparator = '\u001D';
            const bridgeKey = '__amalynAutocompleteSemanticsBridge';
            const bridge = globalThis[bridgeKey] || {
                registry: new Map(),
                observedRoots: new Set(),
                observers: [],
                scheduled: false,
            };
            globalThis[bridgeKey] = bridge;
            const schedule = () => {
                if (bridge.scheduled) {
                    return;
                }
                bridge.scheduled = true;
                requestAnimationFrame(() => {
                    bridge.scheduled = false;
                    synchronizeAll();
                });
            };
            const collectRoots = (root) => [
                root,
                ...Array.from(root.querySelectorAll('*'))
                    .filter((element) => element.shadowRoot)
                    .flatMap((element) => collectRoots(element.shadowRoot)),
            ];
            const ensureObservers = () => {
                collectRoots(document).forEach((root) => {
                    if (bridge.observedRoots.has(root)) {
                        return;
                    }
                    const observer = new MutationObserver(schedule);
                    observer.observe(root, {
                        subtree: true,
                        childList: true,
                        attributes: true,
                        attributeFilter: ['aria-label', 'role'],
                    });
                    bridge.observedRoots.add(root);
                    bridge.observers.push(observer);
                });
            };
            const setAttribute = (element, name, value) => {
                if (element.getAttribute(name) !== value) {
                    element.setAttribute(name, value);
                }
            };
            const removeAttribute = (element, name) => {
                if (element.hasAttribute(name)) {
                    element.removeAttribute(name);
                }
            };
            const synchronize = (config, elements) => {
                const markerSuffix = (elementKey) =>
                    markerSeparator + config.semanticId + markerSeparator + elementKey;
                const findElement = (elementKey) =>
                    elements.find((element) =>
                        element.getAttribute('data-amalyn-autocomplete-id') === config.semanticId &&
                        element.getAttribute('data-amalyn-autocomplete-element') === elementKey
                    ) || elements.find((element) =>
                        (element.getAttribute('aria-label') || '').endsWith(markerSuffix(elementKey))
                    );
                const rememberElement = (element, elementKey) => {
                    if (!element) {
                        return;
                    }
                    setAttribute(element, 'data-amalyn-autocomplete-id', config.semanticId);
                    setAttribute(element, 'data-amalyn-autocomplete-element', elementKey);
                };
                const anchor = findElement('anchor');
                const input = findElement('input');
                const target = input || anchor;
                if (!target) {
                    return;
                }
                rememberElement(anchor, 'anchor');
                rememberElement(input, 'input');
                if (input && anchor && input !== anchor) {
                    setAttribute(anchor, 'role', 'presentation');
                    removeAttribute(anchor, 'aria-label');
                    removeAttribute(anchor, 'aria-expanded');
                    removeAttribute(anchor, 'aria-controls');
                    removeAttribute(anchor, 'aria-activedescendant');
                }
                if (config.readOnly) {
                    setAttribute(target, 'role', 'textbox');
                    setAttribute(target, 'aria-label', config.label);
                    setAttribute(target, 'aria-readonly', 'true');
                    removeAttribute(target, 'aria-autocomplete');
                    removeAttribute(target, 'aria-haspopup');
                    removeAttribute(target, 'aria-expanded');
                    removeAttribute(target, 'aria-controls');
                    removeAttribute(target, 'aria-activedescendant');
                    return;
                }
                setAttribute(target, 'role', 'combobox');
                setAttribute(target, 'aria-label', config.label);
                removeAttribute(target, 'aria-readonly');
                setAttribute(target, 'aria-autocomplete', 'list');
                setAttribute(target, 'aria-haspopup', 'listbox');
                setAttribute(target, 'aria-expanded', String(config.expanded));
                const listboxId = config.semanticId + '-listbox';
                setAttribute(target, 'aria-controls', listboxId);
                if (!config.expanded) {
                    removeAttribute(target, 'aria-activedescendant');
                    return;
                }
                const listbox = findElement('listbox');
                if (!listbox) {
                    return;
                }
                rememberElement(listbox, 'listbox');
                setAttribute(listbox, 'id', listboxId);
                setAttribute(listbox, 'role', 'listbox');
                setAttribute(listbox, 'aria-label', config.label + ' options');
                if (config.multiSelectable) {
                    setAttribute(listbox, 'aria-multiselectable', 'true');
                } else {
                    removeAttribute(listbox, 'aria-multiselectable');
                }
                let activeOptionId = null;
                config.options.forEach((option, index) => {
                    const elementKey = 'option-' + index;
                    const optionElement = findElement(elementKey);
                    if (!optionElement) {
                        return;
                    }
                    rememberElement(optionElement, elementKey);
                    const optionId = config.semanticId + '-option-' + index;
                    setAttribute(optionElement, 'id', optionId);
                    setAttribute(optionElement, 'role', 'option');
                    setAttribute(optionElement, 'aria-label', option.label);
                    setAttribute(optionElement, 'aria-selected', String(option.selected));
                    setAttribute(optionElement, 'aria-posinset', String(index + 1));
                    setAttribute(optionElement, 'aria-setsize', String(config.options.length));
                    if (index === config.activeOptionIndex) {
                        activeOptionId = optionId;
                    }
                });
                if (activeOptionId) {
                    setAttribute(target, 'aria-activedescendant', activeOptionId);
                } else {
                    removeAttribute(target, 'aria-activedescendant');
                }
            };
            const synchronizeAll = () => {
                ensureObservers();
                const elements = collectRoots(document)
                    .flatMap((root) => Array.from(root.querySelectorAll('[aria-label], [data-amalyn-autocomplete-id]')));
                bridge.registry.forEach((config) => synchronize(config, elements));
            };
            const options = (encodedOptions ? encodedOptions.split(listSeparator) : []).map((row) => {
                const separatorIndex = row.indexOf(stateSeparator);
                return {
                    selected: row.slice(0, separatorIndex) === '1',
                    label: row.slice(separatorIndex + 1),
                };
            });
            bridge.registry.set(semanticId, {
                semanticId,
                label,
                expanded,
                multiSelectable,
                readOnly,
                activeOptionIndex,
                options,
            });
            synchronizeAll();
        },
    'com.amalyncare.uikit.components.forms.unregisterAutocompleteSemanticsNative' : (semanticId) => {
            const bridgeKey = '__amalynAutocompleteSemanticsBridge';
            const bridge = globalThis[bridgeKey];
            if (!bridge) {
                return;
            }
            bridge.registry.delete(semanticId);
            if (bridge.registry.size === 0) {
                bridge.observers.forEach((observer) => observer.disconnect());
                delete globalThis[bridgeKey];
            }
        },
    'com.amalyncare.uikit.components.forms.preventNativeComposeKeyboardEditing' : (event) => {
            const input = event.composedPath()[0];
            if (!input?.classList?.contains("compose-backing-field") ||
                (input.tagName !== "INPUT" && input.tagName !== "TEXTAREA") ||
                !event.code || event.isComposing || event.keyCode === 229) return;

            const editingKey = ["Backspace", "Delete", "ArrowLeft", "ArrowRight",
                "ArrowUp", "ArrowDown", "Home", "End"].includes(event.key);
            const selectAll = (event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "a";
            if (!editingKey && !selectAll) return;

            const platform = navigator.userAgentData?.platform || navigator.platform;
            if (event.altKey && !/mac/i.test(platform) &&
                (event.key === "ArrowLeft" || event.key === "ArrowRight")) return;

            // Compose queues these keys for the next animation frame. Cancel the browser's
            // immediate edit/caret movement, while leaving the key available to Compose.
            event.preventDefault();
        },
    'com.amalyncare.uikit.components.forms.activeComposeInputValue' : () => {
            const root = document.getElementById("root");
            const composeHost = Array.from(root?.querySelectorAll("*") ?? []).find(candidate => candidate.shadowRoot);
            const active = composeHost?.shadowRoot?.activeElement;
            if (!active || (active.tagName !== "INPUT" && active.tagName !== "TEXTAREA")) {
                return null;
            }
            return active.value ?? "";
        },
    'com.amalyncare.uikit.components.forms.clipboardEventText' : (event) => event.clipboardData?.getData('text/plain') ?? '',
    'com.amalyncare.uikit.components.internal.focusActionCanvas' : (canvas) => canvas.focus({ preventScroll: true }),
    'com.amalyncare.uikit.components.shell.synchronizePortalNavigationSemanticsNative' : (encodedItems) => {
            const listSeparator = '\u001F';
            const stateSeparator = '\u001E';
            const items = (encodedItems ? encodedItems.split(listSeparator) : []).map((row) => {
                const separatorIndex = row.indexOf(stateSeparator);
                return {
                    kind: row.slice(0, 1),
                    state: row.slice(1, separatorIndex) === '1',
                    label: row.slice(separatorIndex + 1),
                };
            });
            if (items.length === 0) {
                return true;
            }
            const collectRoots = (root) => [
                root,
                ...Array.from(root.querySelectorAll('*'))
                    .filter((element) => element.shadowRoot)
                    .flatMap((element) => collectRoots(element.shadowRoot)),
            ];
            const buttons = collectRoots(document)
                .flatMap((root) => Array.from(root.querySelectorAll('[role="button"][aria-label]')));
            const navigationRoot = buttons
                .filter((button) => button.getAttribute('aria-label') === items[0].label)
                .map((button) => button.parentElement)
                .find((candidate) => {
                    if (!candidate) {
                        return false;
                    }
                    const candidateButtons = Array.from(candidate.querySelectorAll('[role="button"][aria-label]'));
                    return candidateButtons.length === items.length &&
                        candidateButtons.every((button, index) => button.getAttribute('aria-label') === items[index].label);
                });
            if (!navigationRoot) {
                return false;
            }
            const navigationButtons = Array.from(navigationRoot.querySelectorAll('[role="button"][aria-label]'));
            navigationButtons.forEach((button, index) => {
                const item = items[index];
                if (item.kind === 'd') {
                    if (item.state) {
                        button.setAttribute('aria-current', 'page');
                    } else {
                        button.removeAttribute('aria-current');
                    }
                } else {
                    button.setAttribute('aria-expanded', String(item.state));
                }
            });
            return true;
        },
    'com.amalyncare.fe.ui.shared.browser.jsArrayBufferByteLength' : (buffer) => buffer.byteLength,
    'com.amalyncare.fe.ui.shared.browser.jsCopyArrayBufferToWasmMemory' : (buffer, address) => { new Uint8Array(wasmExports.memory.buffer).set(new Uint8Array(buffer), address); },
    'com.amalyncare.fe.ui.shared.browser.jsEmptyUint8Array' : () => new Uint8Array(0),
    'com.amalyncare.fe.ui.shared.browser.jsCopyWasmMemoryToUint8Array' : (address, size) => new Uint8Array(wasmExports.memory.buffer, address, size).slice(),
    'com.amalyncare.fe.ui.shared.browser.acquireBrowserSessionLock' : (origin, namespace) => {
        const abort = new AbortController();
        let release;
        const acquired = new Promise((resolve, reject) => {
            navigator.locks.request('amalyncare:bff-session-cookie:' + origin + ':' + namespace,
                { mode: 'exclusive', signal: abort.signal }, async () => {
                    const held = new Promise(done => { release = done; });
                    resolve(true);
                    await held;
                }).catch(reject);
        });
        return { abort, acquired, release: () => release?.() };
    },
    'com.amalyncare.fe.ui.shared.browser.browserBffOrigin' : url => new URL(url, window.location.href).origin,
    'com.amalyncare.fe.ui.shared.browser.browserSessionLockAcquired' : lock => lock.acquired,
    'com.amalyncare.fe.ui.shared.browser.releaseBrowserSessionLock' : lock => { lock.abort.abort(); lock.release(); },
    'com.amalyncare.fe.ui.shared.browser.jsPrepareFeedPhoto' : 
        (file, maxEdge, thumbnailEdge, quality, thumbnailQuality) => (async () => {
            const url = URL.createObjectURL(file);
            try {
                const image = new Image();
                image.src = url;
                try {
                    await image.decode();
                } catch (error) {
                    return null;
                }
                if (!image.naturalWidth || !image.naturalHeight) {
                    return null;
                }
                const draw = (source, sourceWidth, sourceHeight, edge) => {
                    const scale = Math.min(1, edge / Math.max(sourceWidth, sourceHeight));
                    const canvas = document.createElement('canvas');
                    canvas.width = Math.max(1, Math.round(sourceWidth * scale));
                    canvas.height = Math.max(1, Math.round(sourceHeight * scale));
                    const context = canvas.getContext('2d');
                    context.fillStyle = '#ffffff';
                    context.fillRect(0, 0, canvas.width, canvas.height);
                    context.imageSmoothingEnabled = true;
                    context.imageSmoothingQuality = 'high';
                    context.drawImage(source, 0, 0, canvas.width, canvas.height);
                    return canvas;
                };
                const encode = (canvas, encodeQuality) => new Promise((resolve, reject) => canvas.toBlob(
                    (blob) => blob ? resolve(blob) : reject(new Error('The photo could not be encoded.')),
                    'image/jpeg',
                    encodeQuality,
                ));
                const photo = draw(image, image.naturalWidth, image.naturalHeight, maxEdge);
                const thumbnail = draw(photo, photo.width, photo.height, thumbnailEdge);
                const photoBlob = await encode(photo, quality);
                const thumbnailBlob = await encode(thumbnail, thumbnailQuality);
                return {
                    photo: await photoBlob.arrayBuffer(),
                    thumbnail: await thumbnailBlob.arrayBuffer(),
                    width: photo.width,
                    height: photo.height,
                };
            } finally {
                URL.revokeObjectURL(url);
            }
        })()
        ,
    'com.amalyncare.fe.ui.shared.browser.photo_$external_prop_getter' : (_this) => _this.photo,
    'com.amalyncare.fe.ui.shared.browser.thumbnail_$external_prop_getter' : (_this) => _this.thumbnail,
    'com.amalyncare.fe.ui.shared.browser.width_$external_prop_getter' : (_this) => _this.width,
    'com.amalyncare.fe.ui.shared.browser.height_$external_prop_getter' : (_this) => _this.height,
    'com.amalyncare.fe.ui.shared.browser.browserLoadedRevision' : () => document.querySelector('meta[name="amalyncare-build-revision"]')?.content ?? null,
    'com.amalyncare.fe.ui.shared.browser.browserRevisionText' : value => typeof value === 'string' ? value : null,
    'com.amalyncare.fe.ui.shared.browser.browserFetchRevision' : () => {
        const abort = new AbortController();
        const timeout = setTimeout(() => abort.abort(), 3000);
        return fetch('/healthz', { cache: 'no-store', signal: abort.signal })
            .then(response => response.ok ? response.text() : null)
            .finally(() => clearTimeout(timeout));
    },
    'com.amalyncare.fe.ui.shared.browser.readReloadMarker' : app => { try { return sessionStorage.getItem('amalyncare-version-reload-' + app); } catch (_) { return null; } },
    'com.amalyncare.fe.ui.shared.browser.markReloadForRevision' : (app, timestamp) => {
        try {
            const key = 'amalyncare-version-reload-' + app;
            sessionStorage.setItem(key, String(timestamp));
            return true;
        } catch (_) { return false; }
    },
    'com.amalyncare.fe.ui.shared.browser.browserReload' : () => window.location.reload(),
    'com.amalyncare.fe.ui.shared.browser.browserVersionNowNumber' : () => Date.now(),
    'com.amalyncare.fe.ui.shared.browser.jsBrowserPushAvailability' : () => !globalThis.isSecureContext || !('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window) || !('indexedDB' in window) ? 'unsupported' : Notification.permission,
    'com.amalyncare.fe.ui.shared.browser.jsCurrentBrowserPushSubscription' : () => (async () => {
            if (!globalThis.isSecureContext || !navigator.serviceWorker) return null;
            const registration = await navigator.serviceWorker.getRegistration('/');
            if (!registration || !registration.active || new URL(registration.active.scriptURL).pathname !== '/browser-push-worker.js') return null;
            return registration.pushManager.getSubscription();
        })(),
    'com.amalyncare.fe.ui.shared.browser.jsSubscribeBrowserPush' : (applicationServerKey) => {
            if (!globalThis.isSecureContext || !navigator.serviceWorker || !('PushManager' in window) ||
                !('Notification' in window) || !('indexedDB' in window)) {
                return Promise.reject(new Error('Browser push is unavailable.'));
            }
            if (!/^[A-Za-z0-9_-]+$/.test(applicationServerKey)) return Promise.reject(new Error('The push application key is invalid.'));
            const padded = applicationServerKey.replace(/-/g, '+').replace(/_/g, '/');
            const bytes = Uint8Array.from(atob(padded.padEnd(Math.ceil(padded.length / 4) * 4, '=')), char => char.charCodeAt(0));
            if (bytes.length !== 65 || bytes[0] !== 4) return Promise.reject(new Error('The push application key is invalid.'));
            const permission = Notification.permission === 'default'
                ? Notification.requestPermission() : Promise.resolve(Notification.permission);
            return (async () => {
                if (await permission !== 'granted') throw new Error('Browser notification permission was not granted.');
                const registration = await navigator.serviceWorker.register('/browser-push-worker.js', { scope: '/' });
                const active = registration.active ? registration : await navigator.serviceWorker.ready;
                if (!active.active || new URL(active.active.scriptURL).pathname !== '/browser-push-worker.js') {
                    throw new Error('The browser push worker is unavailable.');
                }
                let subscription = await active.pushManager.getSubscription();
                const oldKey = subscription?.options?.applicationServerKey;
                if (oldKey && (oldKey.byteLength !== bytes.length ||
                    new Uint8Array(oldKey).some((value, index) => value !== bytes[index]))) {
                    await subscription.unsubscribe();
                    subscription = null;
                }
                if (!subscription) subscription = await active.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: bytes });
                return subscription;
            })();
        },
    'com.amalyncare.fe.ui.shared.browser.jsBrowserPushWorkerMessage' : (type, bindingToken) => (async () => {
            if (!navigator.serviceWorker) {
                if (type === 'get-binding') return { bindingToken: null };
                if (type === 'clear') return { ok: true };
                throw new Error('Browser push is unavailable.');
            }
            let registration = await navigator.serviceWorker.getRegistration('/');
            if (!registration && type === 'get-binding') return { bindingToken: null };
            if (!registration && type === 'clear') registration = await navigator.serviceWorker.register('/browser-push-worker.js', { scope: '/' });
            if (!registration?.active && registration) registration = await navigator.serviceWorker.ready;
            if (!registration?.active || new URL(registration.active.scriptURL).pathname !== '/browser-push-worker.js') {
                throw new Error('The browser push worker is unavailable.');
            }
            return new Promise((resolve, reject) => {
                const channel = new MessageChannel();
                const timeout = setTimeout(() => { channel.port1.close(); reject(new Error('The browser push worker did not respond.')); }, 5000);
                channel.port1.onmessage = event => {
                    clearTimeout(timeout);
                    channel.port1.close();
                    event.data?.ok === true ? resolve(event.data) : reject(new Error('The browser push worker request failed.'));
                };
                registration.active.postMessage({ type, bindingToken }, [channel.port2]);
            });
        })(),
    'com.amalyncare.fe.ui.shared.browser.jsWorkerBindingToken' : result => result.bindingToken || '',
    'com.amalyncare.fe.ui.shared.browser.jsWorkerCleared' : result => result.cleared === true,
    'com.amalyncare.fe.ui.shared.browser.jsPushEndpoint' : subscription => subscription.endpoint,
    'com.amalyncare.fe.ui.shared.browser.jsPushKey' : (subscription, name) => { const key = subscription.getKey(name); if (!key) return ''; return btoa(String.fromCharCode(...new Uint8Array(key))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); },
    'com.amalyncare.fe.ui.shared.communication.communicationBrowserVisible' : () => document.visibilityState === 'visible',
    'com.amalyncare.fe.ui.shared.communication.encodeTicket' : (ticket) => encodeURIComponent(ticket),
    'com.amalyncare.fe.ui.shared.communication.newEventSource' : (url) => new EventSource(url, { withCredentials: true }),
    'com.amalyncare.fe.ui.shared.communication.logCommunicationStreamFailure' : (reason) => console.error('Communication stream stopped: ' + reason + '.'),
    'com.amalyncare.fe.ui.shared.communication.onopen_$external_prop_setter' : (_this, v) => _this.onopen = v,
    'com.amalyncare.fe.ui.shared.communication.onmessage_$external_prop_setter' : (_this, v) => _this.onmessage = v,
    'com.amalyncare.fe.ui.shared.communication.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
    'com.amalyncare.fe.ui.shared.communication.close_$external_fun' : (_this, ) => _this.close(),
    'com.amalyncare.fe.ui.shared.communication.data_$external_prop_getter' : (_this) => _this.data,
    'com.amalyncare.fe.ui.shared.overlay.applyBrowserOverlayRootPresentation' : (rootId, presentation) => {
            const mainRoot = document.getElementById('root');
            const overlayRoot = document.getElementById(rootId);
            if (!mainRoot || !overlayRoot) return;

            const previousPresentation = overlayRoot.__amalynPresentation;
            if (previousPresentation === presentation) return;

            const ownsInput = (value) => value === 'nonmodal' || value === 'modal';
            const previousInputOwning = ownsInput(previousPresentation);
            const inputOwning = ownsInput(presentation);
            const restoreMainRootState = () => {
                if (!overlayRoot.__amalynMainRootStateCaptured) return;
                if (overlayRoot.__amalynPreviousMainInert) mainRoot.setAttribute('inert', '');
                else mainRoot.removeAttribute('inert');
                const previousAriaHidden = overlayRoot.__amalynPreviousMainAriaHidden;
                if (previousAriaHidden == null) mainRoot.removeAttribute('aria-hidden');
                else mainRoot.setAttribute('aria-hidden', previousAriaHidden);
            };
            const deepActiveElement = () => {
                let active = document.activeElement;
                while (active?.shadowRoot?.activeElement) active = active.shadowRoot.activeElement;
                return active;
            };
            const focus = (target) => {
                if (!target) return false;
                target.focus?.({ preventScroll: true });
                return deepActiveElement() === target;
            };
            const mainCanvas = () => Array.from(mainRoot.querySelectorAll('*'))
                .map(element => element.shadowRoot?.querySelector('canvas'))
                .find(Boolean);
            const focusOverlayRoot = () => {
                const canvas = Array.from(overlayRoot.querySelectorAll('*'))
                    .map(element => element.shadowRoot?.querySelector('canvas'))
                    .find(Boolean);
                if (canvas) {
                    canvas.tabIndex = 0;
                    canvas.focus({ preventScroll: true });
                }
            };
            const restoreMainRootFocus = () => {
                const previousFocus = overlayRoot.__amalynPreviousFocus;
                const retainedFocus =
                    previousFocus?.isConnected &&
                    previousFocus !== document.body &&
                    previousFocus !== document.documentElement
                        ? previousFocus
                        : null;
                if (!focus(retainedFocus)) focus(mainCanvas());
            };
            const clearMainRootSnapshot = () => {
                delete overlayRoot.__amalynPreviousFocus;
                delete overlayRoot.__amalynPreviousMainAriaHidden;
                delete overlayRoot.__amalynPreviousMainInert;
                delete overlayRoot.__amalynMainRootStateCaptured;
            };

            if (presentation === 'hidden') {
                overlayRoot.style.setProperty('visibility', 'hidden');
                overlayRoot.style.setProperty('pointer-events', 'none');
                overlayRoot.setAttribute('aria-hidden', 'true');
            } else {
                overlayRoot.style.setProperty('visibility', 'visible');
                overlayRoot.style.setProperty('pointer-events', inputOwning ? 'auto' : 'none');
                overlayRoot.removeAttribute('aria-hidden');
            }

            if (inputOwning && !previousInputOwning) {
                overlayRoot.__amalynPreviousFocus = deepActiveElement();
                overlayRoot.__amalynPreviousMainAriaHidden = mainRoot.getAttribute('aria-hidden');
                overlayRoot.__amalynPreviousMainInert = mainRoot.hasAttribute('inert');
                overlayRoot.__amalynMainRootStateCaptured = true;
            }

            if (inputOwning && (!previousInputOwning || presentation === 'modal')) {
                focusOverlayRoot();
            }
            if (presentation === 'modal') {
                mainRoot.setAttribute('inert', '');
                mainRoot.setAttribute('aria-hidden', 'true');
            } else {
                restoreMainRootState();
            }

            if (!inputOwning && previousInputOwning) {
                restoreMainRootFocus();
                clearMainRootSnapshot();
            }
            overlayRoot.__amalynPresentation = presentation;
        },
    'com.amalyncare.fe.ui.shared.personal.navigateFromRecovery' : (token, parent) => { window.location.href = token == null ? '/' : (parent ? '/invitation?key=' : '/staff-invitation?token=') + encodeURIComponent(token); },
    'com.amalyncare.fe.ui.shared.personal.navigateToRecovery' : token => { window.location.href = '/password-reset' + (token == null ? '' : '?invitation=' + encodeURIComponent(token)); },
    'com.amalyncare.fe.ui.shared.personal.recoveryParameter' : name => new URLSearchParams(window.location.search).get(name),
    'com.amalyncare.fe.ui.shared.personal.clearRecoveryQuery' : () => window.history.replaceState(null, '', window.location.pathname),
    'com.amalyncare.fe.ui.shared.resources.reservePreviewTab' : () => {
        const tab = window.open('about:blank', '_blank');
        if (tab) tab.opener = null;
        return tab;
    },
    'com.amalyncare.fe.ui.shared.resources.deferDownloadUrlRevoke' : (url) => window.setTimeout(() => URL.revokeObjectURL(url), 60000),
    'com.amalyncare.fe.ui.shared.resources.showPreviewTab' : (tab, url) => {
        if (tab.closed) return false;
        try { tab.location.replace(url); } catch (_) { return false; }
        const timer = window.setInterval(() => {
            if (!tab.closed) return;
            window.clearInterval(timer);
            URL.revokeObjectURL(url);
        }, 1000);
        return true;
    },
    'com.amalyncare.fe.ui.shared.resources.closePreviewTab' : (tab) => { if (!tab.closed) tab.close(); },
    'com.amalyncare.fe.ui.shared.resources.decodeURIComponent' : (value) => decodeURIComponent(value),
    'com.amalyncare.fe.ui.shared.resources.guideScrollDelta' : (event) => typeof event.detail === 'number' && Number.isFinite(event.detail) ? event.detail : 0,
    'com.amalyncare.fe.ui.shared.resources.clickedDownloadKey' : (event) => {
        return typeof event.detail?.downloadKey === 'string' ? event.detail.downloadKey : null;
    },
    'com.amalyncare.fe.ui.shared.resources.clickedLinkHref' : (event) => {
        return typeof event.detail?.href === 'string' ? event.detail.href : null;
    },
    'com.amalyncare.fe.ui.shared.resources.disconnectGuideResizeObserver' : (observer) => observer.disconnect(),
    'com.amalyncare.fe.ui.shared.resources.disconnectGuideScrollForwarder' : (forwarder) => forwarder.disconnect(),
    'com.amalyncare.fe.ui.shared.resources.disconnectGuideClickForwarder' : (forwarder) => forwarder.disconnect(),
    'com.amalyncare.fe.ui.shared.resources.replaceGuideLinks' : (guideDocument) => {
        for (const anchor of guideDocument.querySelectorAll('a[href]')) {
            const button = guideDocument.createElement('button');
            button.type = 'button';
            button.className = 'resource-link';
            button.setAttribute('role', 'link');
            button.setAttribute('data-resource-href', anchor.getAttribute('href'));
            button.title = 'Open link in a new tab';
            while (anchor.firstChild) button.appendChild(anchor.firstChild);
            anchor.replaceWith(button);
        }
    },
    'com.amalyncare.fe.ui.shared.resources.decorateDocumentLink' : (guideDocument, key) => {
        for (const link of guideDocument.querySelectorAll('button[data-resource-href]')) {
            const href = link.getAttribute('data-resource-href');
            if (href !== '#resource-link-' + key) continue;
            link.title = 'Open PDF in a new tab';
            link.setAttribute('aria-label', 'Open ' + (link.textContent?.trim() || 'document') + ' PDF in a new tab');
            if (link.nextElementSibling?.matches('button[data-resource-download-key]')) continue;
            const button = guideDocument.createElement('button');
            button.type = 'button';
            button.className = 'resource-download';
            button.setAttribute('data-resource-download-key', key);
            button.setAttribute('aria-label', 'Download ' + (link.textContent?.trim() || 'document'));
            button.textContent = 'Download';
            link.after(button);
        }
    },
    'com.amalyncare.fe.ui.shared.resources.observeGuideClicks' : (frame, guideDocument) => {
        const click = (event) => {
            event.preventDefault();
            const target = event.target;
            if (!target || target.nodeType !== 1) return;
            const download = target.closest('button[data-resource-download-key]');
            const link = download ? null : target.closest('button[data-resource-href]');
            if (!download && !link) return;
            frame.dispatchEvent(new CustomEvent('resource-guide-click', { detail: {
                downloadKey: download?.getAttribute('data-resource-download-key') ?? null,
                href: link?.getAttribute('data-resource-href') ?? null,
            } }));
        };
        guideDocument.addEventListener('click', click);
        return { disconnect() { guideDocument.removeEventListener('click', click); } };
    },
    'com.amalyncare.fe.ui.shared.resources.observeGuideBody' : (frame, body) => {
        const observer = new ResizeObserver(() => frame.dispatchEvent(new Event('resource-guide-resize')));
        observer.observe(body);
        return observer;
    },
    'com.amalyncare.fe.ui.shared.resources.observeGuideScroll' : (frame, guideDocument) => {
        const forward = (delta) => frame.dispatchEvent(new CustomEvent('resource-guide-scroll', { detail: delta }));
        const wheel = (event) => {
            if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
            const pixels = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? frame.clientHeight : 1;
            const delta = event.deltaY * pixels;
            if (!delta) return;
            event.preventDefault();
            forward(delta);
        };
        let startTouch = null;
        let lastTouch = null;
        let touchAxis = null;
        const touchStart = (event) => {
            const touch = event.touches.length === 1 ? event.touches[0] : null;
            lastTouch = touch ? { x: touch.clientX, y: touch.clientY } : null;
            startTouch = lastTouch;
            touchAxis = null;
        };
        const touchMove = (event) => {
            const touch = event.touches.length === 1 ? event.touches[0] : null;
            if (!touch || !lastTouch) { startTouch = null; lastTouch = null; touchAxis = null; return; }
            const deltaX = lastTouch.x - touch.clientX;
            const deltaY = lastTouch.y - touch.clientY;
            lastTouch = { x: touch.clientX, y: touch.clientY };
            const totalX = startTouch.x - touch.clientX;
            const totalY = startTouch.y - touch.clientY;
            if (touchAxis == null && Math.max(Math.abs(totalX), Math.abs(totalY)) >= 3) {
                touchAxis = Math.abs(totalY) >= Math.abs(totalX) ? 'vertical' : 'horizontal';
            }
            if (touchAxis !== 'vertical' || !deltaY) return;
            event.preventDefault();
            forward(deltaY);
        };
        const touchEnd = () => { startTouch = null; lastTouch = null; touchAxis = null; };
        guideDocument.addEventListener('wheel', wheel, { passive: false });
        guideDocument.addEventListener('touchstart', touchStart, { passive: true });
        guideDocument.addEventListener('touchmove', touchMove, { passive: false });
        guideDocument.addEventListener('touchend', touchEnd);
        guideDocument.addEventListener('touchcancel', touchEnd);
        return { disconnect() {
            guideDocument.removeEventListener('wheel', wheel);
            guideDocument.removeEventListener('touchstart', touchStart);
            guideDocument.removeEventListener('touchmove', touchMove);
            guideDocument.removeEventListener('touchend', touchEnd);
            guideDocument.removeEventListener('touchcancel', touchEnd);
        } };
    },
    'com.amalyncare.fe.ui.shared.resources.intrinsicGuideHeight' : (guideDocument) => Math.ceil(guideDocument.body?.getBoundingClientRect().height || 0) + 2,
    'com.amalyncare.fe.ui.shared.session.browserEventIsTrusted' : event => event.isTrusted === true,
    'com.amalyncare.fe.ui.shared.session.publishActivity' : (key, identity, timestamp) => { try { localStorage.setItem(key, identity + '|' + timestamp); localStorage.removeItem(key); } catch (_) {} },
    'com.amalyncare.fe.ui.shared.session.browserStorageActivity' : (event, key) => event.key === key && typeof event.newValue === 'string' ? event.newValue : null,
    'com.amalyncare.fe.ui.shared.session.publishSetting' : (key, identity, timestamp, minutes) => {
            try {
                localStorage.setItem(key, identity + '|' + timestamp + '|' + minutes);
                localStorage.removeItem(key);
            } catch (_) {}
        },
    'com.amalyncare.fe.ui.shared.session.browserNowNumber' : () => Date.now(),
    'com.amalyncare.fe.ui.shared.session.browserParseNumber' : value => Date.parse(value),
    'com.amalyncare.fe.ui.shared.time.browserDateTime' : (value, timeZoneId, includeTimeZone) => {
              if (!/^\d{4}-\d{2}-\d{2}T.*(Z|[+-]\d{2}:?\d{2})$/i.test(value)) return "";
              const date = new Date(value);
              if (Number.isNaN(date.getTime())) return "";
              let formatter;
              try {
                formatter = new Intl.DateTimeFormat("en-CA", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                  hour: "numeric",
                  minute: "2-digit",
                  hour12: true,
                  ...(includeTimeZone ? { timeZoneName: "short" } : {}),
                  timeZone: timeZoneId
                });
              } catch (_) {
                return "";
              }
              const parts = formatter.formatToParts(date);
              const part = (type) => {
                const match = parts.find((entry) => entry.type === type);
                return match ? match.value : "";
              };
              const dateText = part("month") + " " + part("day") + ", " + part("year");
              const periodText = part("dayPeriod").toLowerCase().replace(/\s+/g, "").replace(/\./g, "");
              const timeText = part("hour") + ":" + part("minute") + " " + periodText;
              const zoneText = part("timeZoneName");
              return (dateText + ", " + timeText + (zoneText ? " " + zoneText : "")).trim();
            },
    'com.amalyncare.fe.ui.shared.time.browserTime' : (value, timeZoneId, includeTimeZone) => {
              if (!/^\d{4}-\d{2}-\d{2}T.*(Z|[+-]\d{2}:?\d{2})$/i.test(value)) return "";
              const date = new Date(value);
              if (Number.isNaN(date.getTime())) return "";
              try {
                const formatter = new Intl.DateTimeFormat("en-CA", {
                  hour: "2-digit", minute: "2-digit", hourCycle: "h23", timeZone: timeZoneId,
                  ...(includeTimeZone ? { timeZoneName: "short" } : {})
                });
                const parts = formatter.formatToParts(date);
                const part = (type) => parts.find((entry) => entry.type === type)?.value || "";
                const zone = part("timeZoneName");
                return part("hour") + ":" + part("minute") + (zone ? " " + zone : "");
              } catch (_) {
                return "";
              }
            },
    'com.amalyncare.fe.ui.shared.time.browserSiteLocalTimeOf' : (instant, timeZoneId) => {
              const at = new Date(instant);
              if (Number.isNaN(at.getTime())) return "";
              try {
                const p = Object.fromEntries(new Intl.DateTimeFormat("en-CA", {
                  timeZone: timeZoneId, hourCycle: "h23",
                  year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit"
                }).formatToParts(at).map((x) => [x.type, x.value]));
                return p.year + "-" + p.month + "-" + p.day + " " + String(+p.hour % 24).padStart(2, "0") + ":" + p.minute;
              } catch (_) {
                return "";
              }
            },
    'com.amalyncare.fe.ui.shared.time.browserSiteTodayIsoDate' : (timeZoneId) => {
              try {
                const parts = new Intl.DateTimeFormat("en-CA", {
                  timeZone: timeZoneId,
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit"
                }).formatToParts(new Date());
                const part = (type) => parts.find((entry) => entry.type === type)?.value || "";
                const year = part("year");
                const month = part("month");
                const day = part("day");
                return year && month && day ? year + "-" + month + "-" + day : "";
              } catch (_) {
                return "";
              }
            },
    'com.amalyncare.fe.ui.shared.time.browserResolveSiteLocalTime' : (date, time, timeZoneId) => {
              const d = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
              const t = /^(\d{2}):(\d{2})$/.exec(time);
              if (!d || !t) return "";
              const wall = Date.UTC(+d[1], +d[2] - 1, +d[3], +t[1], +t[2]);
              const check = new Date(wall);
              if (check.getUTCFullYear() !== +d[1] || check.getUTCMonth() !== +d[2] - 1 || check.getUTCDate() !== +d[3] ||
                  +t[1] > 23 || +t[2] > 59) return "";
              let formatter;
              try {
                formatter = new Intl.DateTimeFormat("en-CA", {
                  timeZone: timeZoneId, hourCycle: "h23",
                  year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit"
                });
              } catch (_) {
                return "";
              }
              const wallAt = (ms) => {
                const p = Object.fromEntries(formatter.formatToParts(new Date(ms)).map((x) => [x.type, x.value]));
                return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute);
              };
              const offsets = [...new Set([-12, 0, 12].map((h) => wallAt(wall + h * 3600000) - (wall + h * 3600000)))];
              const candidates = offsets.map((o) => wall - o).filter((ms) => wallAt(ms) === wall).sort((a, b) => a - b);
              if (candidates.length === 0) return "skipped";
              const instant = candidates[0];
              const offsetMinutes = Math.round((wall - instant) / 60000);
              const sign = offsetMinutes < 0 ? "-" : "+";
              const abs = Math.abs(offsetMinutes);
              const pad = (n) => String(n).padStart(2, "0");
              return date + "T" + time + ":00" + sign + pad(Math.floor(abs / 60)) + ":" + pad(abs % 60);
            },
    'com.amalyncare.fe.ui.shared.time.browserResolvedTimeZoneId' : () => {
              try {
                return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
              } catch (_) {
                return "";
              }
            },
    'com.amalyncare.maps.browser.MapLibreMap_$external_fun' : (p0) => new _ref_bWFwbGlicmUtZ2w_.Map(p0),
    'com.amalyncare.maps.browser.addControl_$external_fun' : (_this, p0, p1) => _this.addControl(p0, p1),
    'com.amalyncare.maps.browser.easeTo_$external_fun' : (_this, p0) => _this.easeTo(p0),
    'com.amalyncare.maps.browser.getZoom_$external_fun' : (_this, ) => _this.getZoom(),
    'com.amalyncare.maps.browser.on_$external_fun' : (_this, p0, p1) => _this.on(p0, p1),
    'com.amalyncare.maps.browser.remove_$external_fun' : (_this, ) => _this.remove(),
    'com.amalyncare.maps.browser.resize_$external_fun' : (_this, ) => _this.resize(),
    'com.amalyncare.maps.browser.MapLibreNavigationControl_$external_fun' : (p0, isDefault0) => new _ref_bWFwbGlicmUtZ2w_.NavigationControl(isDefault0 ? undefined : p0, ),
    'com.amalyncare.maps.browser.MapLibreAttributionControl_$external_fun' : (p0, isDefault0) => new _ref_bWFwbGlicmUtZ2w_.AttributionControl(isDefault0 ? undefined : p0, ),
    'com.amalyncare.maps.browser.MapLibrePopup_$external_fun' : (p0, isDefault0) => new _ref_bWFwbGlicmUtZ2w_.Popup(isDefault0 ? undefined : p0, ),
    'com.amalyncare.maps.browser.setLngLat_$external_fun' : (_this, p0) => _this.setLngLat(p0),
    'com.amalyncare.maps.browser.setHTML_$external_fun' : (_this, p0) => _this.setHTML(p0),
    'com.amalyncare.maps.browser.setOffset_$external_fun' : (_this, p0) => _this.setOffset(p0),
    'com.amalyncare.maps.browser.addTo_$external_fun' : (_this, p0) => _this.addTo(p0),
    'com.amalyncare.maps.browser.remove_$external_fun_1' : (_this, ) => _this.remove(),
    'com.amalyncare.maps.browser.MapLibreMarker_$external_fun' : (p0, isDefault0) => new _ref_bWFwbGlicmUtZ2w_.Marker(isDefault0 ? undefined : p0, ),
    'com.amalyncare.maps.browser.setLngLat_$external_fun_1' : (_this, p0) => _this.setLngLat(p0),
    'com.amalyncare.maps.browser.addTo_$external_fun_1' : (_this, p0) => _this.addTo(p0),
    'com.amalyncare.maps.browser.getElement_$external_fun' : (_this, ) => _this.getElement(),
    'com.amalyncare.maps.browser.remove_$external_fun_2' : (_this, ) => _this.remove(),
    'com.amalyncare.maps.browser.navigationControlOptions' : () => ({showCompass: false, showZoom: true, visualizePitch: false}),
    'com.amalyncare.maps.browser.longitudeLatitude' : (ignored, expected) => [ignored, expected],
    'com.amalyncare.maps.browser.markerOptions' : (ignored, expected) => ({color: ignored, title: expected, anchor: 'bottom', offset: [0, 0]}),
    'com.amalyncare.maps.browser.popupOptions' : () => ({closeButton: false, closeOnClick: false}),
    'com.amalyncare.maps.browser.popupOffsets' : (ignored, expected) => (() => {
                const markerRect = ignored.getBoundingClientRect();
                const visibleRects = Array.from(ignored.querySelectorAll('*'))
                    .map((part) => part.getBoundingClientRect())
                    .filter((rect) => rect.width > 0 && rect.height > 0);
                const parts = visibleRects.length > 0 ? visibleRects : [markerRect];
                const markerTop = Math.min(...parts.map((rect) => rect.top));
                const markerBottom = Math.max(...parts.map((rect) => rect.bottom));
                const markerLeft = Math.min(...parts.map((rect) => rect.left));
                const markerRight = Math.max(...parts.map((rect) => rect.right));
                const markerCenterX = markerRect.left + markerRect.width / 2;
                const aboveMarkerOffset = -(markerRect.bottom - markerTop + expected);
                const markerVerticalCenterOffset = (markerTop + markerBottom) / 2 - markerRect.bottom;

                return {
                    top: [0, expected],
                    'top-left': [0, expected],
                    'top-right': [0, expected],
                    bottom: [0, aboveMarkerOffset],
                    'bottom-left': [0, aboveMarkerOffset],
                    'bottom-right': [0, aboveMarkerOffset],
                    left: [markerRight - markerCenterX + expected, markerVerticalCenterOffset],
                    right: [-(markerCenterX - markerLeft + expected), markerVerticalCenterOffset],
                    center: [0, aboveMarkerOffset]
                };
            })(),
    'com.amalyncare.maps.browser.mergeOptions' : (ignored, expected) => Object.assign(ignored, expected),
    'com.amalyncare.maps.browser.containerStyleOptions' : (ignored, expected) => ({container: ignored, style: expected}),
    'com.amalyncare.maps.browser.mapCameraOptions' : (ignored, expected) => ({center: ignored, zoom: expected, attributionControl: false}),
    'com.amalyncare.maps.browser.verticalPaddingOptions' : (ignored, expected) => ({top: ignored, bottom: expected}),
    'com.amalyncare.maps.browser.horizontalPaddingOptions' : (ignored, expected) => ({left: ignored, right: expected}),
    'com.amalyncare.maps.browser.focusCameraOptions' : (ignored, expected) => ({center: ignored, zoom: expected, essential: false, retainPadding: false}),
    'com.amalyncare.maps.browser.focusMotionOptions' : (ignored, expected) => ({padding: ignored, duration: expected}),
    'com.amalyncare.maps.browser.ResizeObserver_$external_fun' : (p0) => new ResizeObserver(p0),
    'com.amalyncare.maps.browser.__convertKotlinClosureToJsClosure_((Js,Js)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Js,Js)->Unit)'](f, p0, p1)),
    'com.amalyncare.maps.browser.observe_$external_fun' : (_this, p0) => _this.observe(p0),
    'com.amalyncare.maps.browser.disconnect_$external_fun' : (_this, ) => _this.disconnect(),
    'com.amalyncare.maps.browser.ResizeObserver_$external_class_instanceof' : (x) => x instanceof ResizeObserver,
    'com.amalyncare.maps.browser.ResizeObserver_$external_class_get' : () => ResizeObserver,
    'com.amalyncare.maps.browser.MapLibreCss_$external_object_getInstance' : () => _ref_bWFwbGlicmUtZ2wvZGlzdC9tYXBsaWJyZS1nbC5jc3M_,
    'com.amalyncare.maps.browser.addProtocol_$external_fun' : (_this, p0, p1) => _this.addProtocol(p0, p1),
    'com.amalyncare.maps.browser.MapLibre_$external_object_getInstance' : () => _ref_bWFwbGlicmUtZ2w_,
    'com.amalyncare.maps.browser.PmtilesProtocol_$external_fun' : () => new _ref_cG10aWxlcw_.Protocol(),
    'com.amalyncare.maps.browser.tile_$external_prop_getter' : (_this) => _this.tile,
    'com.amalyncare.fe.ui.browserLocalDate' : (value) => {
              const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
              if (!match) return "";

              const year = Number(match[1]);
              const month = Number(match[2]);
              const day = Number(match[3]);
              const date = new Date(Date.UTC(year, month - 1, day));
              if (
                Number.isNaN(date.getTime()) ||
                date.getUTCFullYear() !== year ||
                date.getUTCMonth() !== month - 1 ||
                date.getUTCDate() !== day
              ) {
                return "";
              }

              const formatter = new Intl.DateTimeFormat("en-CA", {
                month: "short",
                day: "numeric",
                year: "numeric",
                timeZone: "UTC"
              });
              const parts = formatter.formatToParts(date);
              const part = (type) => {
                const found = parts.find((entry) => entry.type === type);
                return found ? found.value : "";
              };
              return part("month") + " " + part("day") + ", " + part("year");
            },
    'com.amalyncare.fe.ui.staffInvitationToken' : () => new URLSearchParams(window.location.search).get('token'),
    'com.amalyncare.fe.ui.clearStaffInvitationQuery' : () => window.history.replaceState(null, '', window.location.pathname),
    'com.amalyncare.fe.ui.newBrowserEntrySession' : () => String(Date.now()) + '-' + String(Math.random()),
    'com.amalyncare.fe.ui.browserEntryState' : (session, index) => ({ amalynNavigation: { session, index } }),
    'com.amalyncare.fe.ui.browserEntryIndex' : (state, session) => state?.amalynNavigation?.session === session && Number.isInteger(state.amalynNavigation.index) ? state.amalynNavigation.index : -1,
    'com.amalyncare.fe.ui.browserNowIsoDateTime' : () => new Date().toISOString(),
    'com.amalyncare.fe.ui.isMapBackgroundClick' : (event) => {
                const target = event.target;
                return target instanceof Element &&
                    target.closest('.amalyncare-map-marker, .maplibregl-ctrl, .maplibregl-popup') === null;
            }
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    